export default function isExternalLink(nav_item) {
    return nav_item.new_tab ? true : false
  }